import LScreen from "@components/LScreen";
import LText from "@components/LText";
import { theme } from "@theme";
import { ActivityIndicator } from "react-native";

export const AccountDeleting = () => {
  return (
    <LScreen
      enableAutomaticTopPadding={true}
      justifyContent="center"
      pb="l2"
      pt="l1"
    >
      <LText textAlign="center" mb="m1">
        Deleting your account, please wait until the process is complete
      </LText>
      <LText textAlign="center" mb="m1">
        You will be automatically logged out once the process is complete
      </LText>
      <ActivityIndicator color={theme.colors.activityIndicator} />
    </LScreen>
  );
};
